import KeenSlider, { type KeenSliderInstance } from 'keen-slider'

const getSlidesViewed = (current: number) => {
  if (isNaN(current)) return current
  let slide = current

  switch (true) {
    case window.matchMedia('(min-width: 1040px)').matches:
      slide = current + 4
      break
    case window.matchMedia('(min-width: 768px)').matches:
      slide = current + 3
      break
    default:
      slide = current + 2
  }

  return slide
}

const setUi = (slider: KeenSliderInstance) => {
  const { container, track } = slider

  const prev = container.querySelector('.content-slider__btn-ctr--left')
  const next = container.querySelector('.content-slider__btn-ctr--right')

  prev?.querySelector('button')?.addEventListener('click', () => slider.prev())
  next?.querySelector('button')?.addEventListener('click', () => slider.next())

  const updateClasses = () => {
    const allSlides = container.querySelectorAll('.keen-slider__slide')

    allSlides.forEach((slide, index) => {
      slide.classList.toggle('active-slide', track.details.slides[index].portion > 0.5)
    })

    const slide = track.details.rel
    const viewedSlides = getSlidesViewed(slide)

    slide === 0
      ? prev?.classList.add('content-slider__btn-ctr--disabled')
      : prev?.classList.remove('content-slider__btn-ctr--disabled')
    viewedSlides === track.details.slides.length
      ? next?.classList.add('content-slider__btn-ctr--disabled')
      : next?.classList.remove('content-slider__btn-ctr--disabled')
  }

  slider.on('created', () => {
    container.classList.add('content-slider__inner--ready')
    updateClasses()
  })
  slider.on('slideChanged', updateClasses)
  slider.on('updated', updateClasses)
}

export function initKeenSlider(id: number | string) {
  new KeenSlider(
    `#slider-${id}`,
    {
      slides: {
        perView: 'auto',
      },
      breakpoints: {
        '(max-width: 768px)': {
          mode: 'free',
        },
        '(max-width: 1040px)': {
          mode: 'free',
        },
      },
    },
    [setUi],
  )
}
